<h1 class="accent-background-element">Review Create Clinic/Office</h1>

<mat-dialog-content>
  <h3>Country: <span class="not-bold">{{getFullCountryName(currentClinicOffice?.countryId)}}</span></h3>
  <h3>Show on the map: <span class="not-bold">{{currentClinicOffice?.shown? 'Yes':'No'}}</span></h3>
  <h3>Type 1: <span class="not-bold">{{getFullType1(currentClinicOffice?.type1)}}</span></h3>
  <h3>Type 2: <span class="not-bold">{{currentClinicOffice?.shopType|titlecase}}</span></h3>
  <h3>Clinic / Office ID: <span class="not-bold">{{currentClinicOffice?.clinicOfficeId}}</span></h3>
  <h3>Name: <span class="not-bold">{{currentClinicOffice?.name}}</span></h3>
  <h3>E-mail: <span class="not-bold">{{currentClinicOffice?.email}}</span></h3>
  <h3>Phone: <span class="not-bold">{{currentClinicOffice?.phone}}</span></h3>
  @if (isOffice) {
    <h3>Website: <span class="not-bold">{{currentClinicOffice?.website}}</span></h3>
  }
  @if (!isOffice) {
    <h3>Brand ID: <span
    class="not-bold">{{currentClinicOffice?.brand?getBrandName(currentClinicOffice?.brand!):''}}</span></h3>
  }

  @if (isUs) {
    <h3>CRM: <span class="not-bold">{{currentClinicOffice?.crmType?
    getCRMNameByNumber(currentClinicOffice?.crmType!):''}}</span></h3>
  }

  @if (isPhysical) {
    <h3>Coordinates: <span class="not-bold">{{currentClinicOffice?.geolocation?.latitude}},
    {{currentClinicOffice?.geolocation?.longitude}}</span></h3>
  }
  @if (isPhysical) {
    <h3>City: <span class="not-bold">{{currentClinicOffice?.city}}</span></h3>
  }
  @if (isPhysical) {
    <h3>Address Line 1: <span class="not-bold">{{currentClinicOffice?.addressLine1}}</span></h3>
  }
  @if (isPhysical) {
    <h3>Address Line 2: <span class="not-bold">{{currentClinicOffice?.addressLine2}}</span></h3>
  }
  @if (isPhysical) {
    <h3>Zip Code: <span class="not-bold">{{currentClinicOffice?.zipCode}}</span></h3>
  }

  @if (isUs && currentClinicOffice && currentClinicOffice.state) {
    <h3>State: <span class="not-bold">{{getStateName(currentClinicOffice.state) }}</span></h3>
  }

  @if (isPhysical && !isOffice) {
    <h3>Opening Hours: </h3>
  }
  @if (isPhysical && !isOffice) {
    <div class="hours">
      <p>Monday:&nbsp; <span>{{(currentClinicOffice?.openingHours &&currentClinicOffice?.openingHours![0].length>0) ?
      currentClinicOffice?.openingHours![0]:"Closed"}}</span></p>
      <p>Tuesday:&nbsp; <span>{{(currentClinicOffice?.openingHours &&currentClinicOffice?.openingHours![1].length>0) ?
      currentClinicOffice?.openingHours![1]:"Closed"}}</span></p>
      <p>Wednesday:&nbsp; <span>{{(currentClinicOffice?.openingHours &&currentClinicOffice?.openingHours![2].length>0)
      ? currentClinicOffice?.openingHours![2]:"Closed"}}</span></p>
      <p>Thursday:&nbsp; <span>{{(currentClinicOffice?.openingHours &&currentClinicOffice?.openingHours![3].length>0)
      ? currentClinicOffice?.openingHours![3]:"Closed"}}</span></p>
      <p>Friday:&nbsp; <span>{{(currentClinicOffice?.openingHours &&currentClinicOffice?.openingHours![4].length>0) ?
      currentClinicOffice?.openingHours![4]:"Closed"}}</span></p>
      <p>Saturday:&nbsp; <span>{{(currentClinicOffice?.openingHours &&currentClinicOffice?.openingHours![5].length>0)
      ? currentClinicOffice?.openingHours![5]:"Closed"}}</span></p>
      <p>Sunday:&nbsp; <span>{{(currentClinicOffice?.openingHours &&currentClinicOffice?.openingHours![6].length>0) ?
      currentClinicOffice?.openingHours![6]:"Closed"}}</span></p>
    </div>
  }
  @if (isOffice) {
    <div>
      <h3>ENT Names: </h3>
      @if (currentClinicOffice?.doctors && currentClinicOffice?.doctors!.length>0) {
        <div class="doctors">
          @for (doctor of currentClinicOffice!.doctors; track doctor; let i = $index) {
            <p>
              {{i+1}}.&nbsp;{{doctor}}
            </p>
          }
        </div>
      } @else {
        <mat-icon svgIcon='dash'></mat-icon>
      }
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions>
  <span class="spacer"></span>
  <button mat-raised-button color="accent" (click)="onSubmit()">Continue</button>
</mat-dialog-actions>



